/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';
import { navigate } from '@reach/router';
import { ButtonDropdown } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
// import Icon from '../Icons';
// import { PUBLIC_ID, PLANNED_ID } from '../CreateIncident/constant';

const QuickStatusMenu = ({ openQuickChange }) => {
  const { t } = useTranslation();
  const goToStatusChangeLogo = () => {
    navigate('/admin/quick-status');
  };
  const options = [
    {
      id: 'ADD',
      name: t('components.changeComponentStatus.quickStatusChange'),
      handleClick: openQuickChange
    },
    {
      id: 'LOG',
      name: t('components.changeComponentStatus.activityLog'),
      handleClick: goToStatusChangeLogo
    }
  ];

  return (
    <StyledQSMenu>
      <ButtonDropdown
        id="multi-click"
        position="bottom"
        onClick={(v: any) => v.handleClick()}
        items={options}
        type="secondary"
        defaultSelectedItem={options[0]}
      />
      {/* <Button
        onClick={e => setAnchorEl(e.currentTarget)}
        aria-describedby="create-incident"
        type="secondary"
        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
      >
        {' '}
        + Quick status change&nbsp;
        <Icon size={12} glyph="arrowdown" />
      </Button>
      <Popover
        id="create-incident"
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
      >
        <Menu
          options={[
            {
              id: 'ADD',
              name: 'Quick status change',
              handleClick: openQuickChange
            },
            {
              id: 'LOG',
              name: 'Quick status change log',
              handleClick: goToStatusChangeLogo
            }
          ]}
          onSelect={v => handleMenuOption(v)}
        />
      </Popover> */}
    </StyledQSMenu>
  );
};

export default QuickStatusMenu;

const StyledQSMenu = styled.div`
  button.nopadding {
    height: 32px;
    margin-top: 1px;
  }
  button.nopadding > :first-child {
    line-height: 1.2;
  }
`;
